import React, { useState } from "react";
import { GetAccess } from "../../../utils/RolesandAccess";
import { AddIcon } from "../../../assets/icons";
import { TableLoader } from "../../../components/Loader";
import UseGetData from "../../../hooks/useFetchData";
import ViewMore from "./viewMore";
import CreateorUpdate from "./form";

function StatusIndex() {
  const { data, getData, isLoading } = UseGetData({ url: "/Status/" });
  const [showMyModal, setShowMyModal] = useState(false);
  console.log("data", data);

  return (
    <>
      <div className=" w-full h-[calc(100vh-140px)] overflow-y-auto">
        <div className="pb-2 px-2 flex justify-between items-center w-full">
          <h4 className="text-sm 2xl:text-base font-medium text-heading">
            Status
          </h4>
          <div className=" w-8 flex justify-center items-center cursor-pointer">
            {GetAccess("admin_create") && (
              <div onClick={() => setShowMyModal(true)}>
                <AddIcon />
              </div>
            )}
          </div>
        </div>
        <div className=" w-full h-[calc(100vh-180px)]  relative overflow-y-auto">
          <div className=" sticky top-0 z-10">
            <table className="table-auto w-full">
              <thead className="bg-tabletitle">
                <tr className="flex items-center text-xs 2xl:text-sm font-medium">
                  {header?.map((header) => (
                    <th
                      className={`text-center py-4 font-medium ${header.width}`}
                    >
                      {header?.headone}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          </div>
          <div>
            <table className="table-auto w-full">
              {isLoading == true ? (
                <>
                  {[...Array(8)].map((_, index) => {
                    return <TableLoader key={index} header={header} />;
                  })}
                </>
              ) : (
                <>
                  {data &&
                    data.map((data, i) => (
                      <tr
                        className="odd:bg-tableodd w-full even:bg-tableeven text-xs 2xl:text-sm py-1 flex justify-between items-center my-1"
                        key={i}
                      >
                        <td
                          className={`text-center px-5 text-gray-900 py-1 w-[15%]`}
                        >
                          {data.id || "#"}
                        </td>
                        <td
                          className={`text-center px-5 text-gray-900 py-1 w-[40%] capitalize`}
                        >
                          {data.module_id === 1
                            ? "Implementation Checklist"
                            : data.module_id === 2
                            ? "Internal Audit Checklist"
                            : data.module_id === 3
                            ? "Maintenance"
                            : data.module_id === 4
                            ? "Master List of Documents"
                            : data.module_id === 5
                            ? "CISO / DPO / ISF Meeting MoM"
                            : data.module_id === 6
                            ? "Audit Schedule"
                            : data.module_id === 7
                            ? "Standard Document"
                            : data.module_id === 8
                            ? "Explanation of Standard"
                            : data.module_id === 9
                            ? "Benefits of standard"
                            : data.module_id === 10
                            ? "Calendar Management"
                            : data.module_id === 11
                            ? "Vendor Management"
                            : data.module_id === 12
                            ? "Security Incident"
                            : data.module_id === 13
                            ? "Abbreviations"
                            : data.module_id === 14
                            ? "Q & A Help"
                            : data.module_id === 15
                            ? "Diagrams / Logo's"
                            : data.module_id === 16
                            ? "Training Calendar"
                            : data.module_id === 17
                            ? "Agenda"
                            : data.module_id === 18
                            ? "CISO / MRM Meeting MoM"
                            : "-"}
                        </td>
                        <td
                          className={`text-center px-5 text-gray-900 py-1 w-[40%] capitalize`}
                        >
                          {data?.status_type || "-"}
                        </td>
                        <td className={`text-center text-gray-900 py-1 w-[5%]`}>
                          <div className=" w-full h-full flex justify-center items-center">
                            <ViewMore data={data} fetcher={getData} />
                          </div>
                        </td>
                      </tr>
                    ))}
                </>
              )}
            </table>
          </div>
        </div>
      </div>
      <CreateorUpdate
        onClose={() => setShowMyModal(false)}
        visible={showMyModal}
        refreshData={getData}
      />
    </>
  );
}

export default StatusIndex;

const header = [
  {
    headone: "SI. No",
    width: "w-[15%]",
  },
  {
    headone: "Module",
    width: "w-[40%]",
  },
  {
    headone: "Status",
    width: "w-[40%]",
  },
  {
    headone: " ",
    width: "w-[5%]",
  },
];
